import styled from 'vue-styled-components';

import theme from '@/config/theme';

export const ButtonLogin = styled('button')`
  background-color: transparent;
  color: ${theme.colors.gray6};
  cursor: pointer;
  font-size: ${theme.font.sizes.p2};
  left: 20px;
  position: absolute;
  top: 20px;

  &:hover {
    opacity: .7;
  }
`;

export const ErrorMessage = styled('p')`
  color: ${theme.colors.supportError};
  font-size: ${theme.font.sizes.p3};
  margin-top: ${theme.spacings.xxxlarge};
  text-align: center;
`;

export const MessageAlertAlt = styled('p')`
  color: #ff8c00;
  font-size: ${theme.font.sizes.p1};
  line-height: ${theme.font.lineHeights.p1};
  margin-top: ${theme.spacings.xxlarge};

  span {
    align-items: center;
    color: ${theme.colors.gray6};
    display: flex;
    font-weight: ${theme.font.bold};

    svg {
      margin-right: ${theme.spacings.xsmall};
    }
  }
`;

export const Message = styled('p')`
  color: ${theme.colors.gray6};
  font-size: ${theme.font.sizes.p1};
  line-height: ${theme.font.lineHeights.p1};
  margin-top: ${theme.spacings.xxlarge};

  span {
    align-items: center;
    color: ${theme.colors.gray6};
    display: flex;
    font-weight: ${theme.font.bold};

    svg {
      margin-right: ${theme.spacings.xsmall};
    }
  }
`;

export const WrapperButton = styled('div')`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-top: ${theme.spacings.xxxlarge};
`;

export const WrapperInput = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings.xxxlarge};
  margin-top: ${theme.spacings.xxxlarge};

  .validation-error {
    color: ${theme.colors.supportError};
    font-size: ${theme.font.sizes.p3};
    margin-top: 5px;
    text-align: right;
  }
`;

export const WrapperMain = styled('main')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
  padding: 30px 0;
`;
